import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=7c6a6a60&scoped=true&functional=true&"
var script = {}
import style0 from "./CardFooter.vue?vue&type=style&index=0&id=7c6a6a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7c6a6a60",
  null
  
)

export default component.exports